import { render } from "./MdButton.vue?vue&type=template&id=160e50fe&scoped=true&ts=true"
import script from "./MdButton.vue?vue&type=script&lang=ts"
export * from "./MdButton.vue?vue&type=script&lang=ts"

import "./MdButton.vue?vue&type=style&index=0&id=160e50fe&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160e50fe"]])

export default __exports__